<template>
	<el-dialog title="拍照&裁剪图片" :visible.sync="data.visible" width="1330px" center :close-on-click-modal="false" @closed="toCloseClick">
		<el-form class="cropperForm">
			<div :style="{display: data.camera.doing ? 'block' : 'none'}">
				<video id="takeImageCamera" ref="camera" :width="data.camera.width" :height="data.camera.height" autoplay />
		      	<canvas style="display:none;" ref="cvsCamera" :width="data.camera.width" :height="data.camera.height" ></canvas>
			</div>
			<el-form-item>
				<el-button icon="el-icon-camera" :disabled="!data.camera.doing" @click="doCamera">抓拍</el-button>
				<el-button icon="el-icon-camera-solid" :disabled="data.camera.doing" @click="reCamera">重拍</el-button>
			</el-form-item>
			<el-row :gutter="20" v-if="!data.camera.doing">
				<el-col :span="12">
					<el-card style="height: 450px;">
						<div slot="header" class="clearfix">
							<span>原始图片</span>
						</div>
						<div class="cropper" style="text-align:center;height:378px;">
							<VueCropper ref="cropper" :img="data.option.img" :outputSize="data.option.outputSize"
								:outputType="data.option.outputType" :info="data.option.info" :mode="data.option.mode"
								:canScale="data.option.canScale" :autoCrop="data.option.autoCrop"
								:autoCropWidth="data.option.autoCropWidth" :autoCropHeight="data.option.autoCropHeight"
								:fixed="data.option.fixed" :fixedBox="data.option.fixedBox"
								:fixedNumber="data.option.fixedNumber" :full="data.option.full"
								:original="data.option.original" :centerBox="data.option.centerBox"
								:infoTrue="data.option.infoTrue" :canMove="data.option.canMove"
								:canMoveBox="data.option.canMoveBox" :high="data.option.high"
								:enlarge="data.option.enlarge" @realTime="VueCropperRealTime">
							</VueCropper>
						</div>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-card style="height: 450px;">
						<div slot="header" class="clearfix">
							<span>处理后的图片</span>
						</div>
						<div class="show-preview" style="width:624px;height:378px;">
							<img ref="prevImg" :src="data.preview"
								style="width:624px;height:378px;object-fit:contain;" />
						</div>
					</el-card>
				</el-col>
			</el-row>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" icon="el-icon-check" @click="toOkClick('blob')" :disabled="!data.canok">确定</el-button>
			<el-button type="primary" icon="el-icon-close" @click="toCloseClick">取消</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import { VueCropper } from 'vue-cropper';
	export default {
		data() {
			return {
				data: {
					selectFileList: [],
					preview: '',
					//previews: {},
					option: {
						img: '', // 裁剪图片的地址
						info: true, // 裁剪框的大小信息
						outputSize: 1, // 裁剪生成图片的质量
						outputType: 'jpg', // 裁剪生成图片的格式
						canScale: true, // 图片是否允许滚轮缩放
						autoCrop: true, // 是否默认生成截图框
						autoCropWidth: 270, // 默认生成截图框宽度
						autoCropHeight: 378, // 默认生成截图框高度
						fixedBox: true, // 固定截图框大小 不允许改变
						fixed: true, // 是否开启截图框宽高固定比例
						fixedNumber: [5, 7], // 截图框的宽高比例
						full: true, // 是否输出原图比例的截图
						centerBox: true, // 截图框是否被限制在图片里面
						infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
						canMove: true, //上传图片是否可以移动
						canMoveBox: false, // 截图框能否拖动
						original: false, //上传图片按照原始比例渲染
						high: true, //是否按照设备的dpr 输出等比例图片
						enlarge: 1, //图片根据截图框输出比例倍数,值范围：0-max(建议不要太大不然会卡死)
						mode: 'auto' //图片默认渲染方式，值范围：contain , cover, 100px, 100% auto
					},
					camera: {
						doing: true,
						width: 1280,
						height: 720
					},
					fileName: '',
					visible: false,
					canok: false
				}

			}
		},
		components: {
			'VueCropper': VueCropper
		},
		props: {
			autoCropWidth: Number,
			autoCropHeight: Number
		},
		methods: {
			init() {
				let ths = this;
				ths.data.visible = true;
				ths.data.canok = false;
				//setTimeout(t => {
				ths.data.selectFileList = [];
				ths.data.preview = '';
				//t.data.previews = {};
				ths.data.fileName = '';
				ths.data.option.img = '';
				ths.data.option.autoCropWidth = ths.autoCropWidth;
				ths.data.option.autoCropHeight = ths.autoCropHeight;
				ths.startCamera();
				//}, 50, ths);
			},
			handleUploadViolationImageSuccess(response, file, fileList) {
				if (!file.request) {
					this.data.option.img = URL.createObjectURL(file.raw);
					this.data.selectFileList = [];
				}

			},
			handleUploadViolationImageError(err, file, fileList) {},
			handleUploadViolationImageChange(file, fileList) {
				if (!file.request) {
					this.data.option.img = URL.createObjectURL(file.raw);
					this.data.selectFileList = [];
				}
			},
			VueCropperRealTime(data) { //debugger
				let ths = this;
				//ths.data.previews = data;
				ths.$refs.cropper.getCropBlob((blob) => {
					ths.data.preview = blob.getURL();
					ths.data.canok = true;
				});
			},
			toOkClick(type) {
				let ths = this;
				//输出blob
				ths.$refs.cropper.getCropBlob((data) => {
					ths.$emit('toOk', data, 'camera');
					ths.data.visible = false;
				});
			},
			toCloseClick() {
				this.stopCamera();
				this.data.visible = false;
			},
			selectImage(eObj) {
				let ths = this;
				let files = eObj.target.files;
				let reader = new FileReader();
				reader.onload = function(e) {
					let imgData;
					if (typeof e.target.result === 'object') {
						imgData = window.URL.createObjectURL(new Blob([e.target.result]))
					} else {
						imgData = e.target.result
					}
					ths.data.option.img = imgData;
				};
				reader.readAsDataURL(files[0]);
			},
			startCamera() {
				let ths = this;
				ths.data.camera.doing = true;
				setTimeout(()=>{
					window.camera = ths.$refs.camera;
					//window.camera = document.getElementById('takeImageCamera');// ths.$refs.camera;
					
					// 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
					if (navigator.mediaDevices === undefined) {
						navigator.mediaDevices = {};
					}
					// 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
					// 使用getUserMedia，因为它会覆盖现有的属性。
					// 这里，如果缺少getUserMedia属性，就添加它。
					if (navigator.mediaDevices.getUserMedia === undefined) {
						navigator.mediaDevices.getUserMedia = function(constraints) {
							// 首先获取现存的getUserMedia(如果存在)
							var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator
								.getUserMedia;
							// 有些浏览器不支持，会返回错误信息
							// 保持接口一致
							if (!getUserMedia) {
								return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
							}
							// 否则，使用Promise将调用包装到旧的navigator.getUserMedia
							return new Promise(function(resolve, reject) {
								getUserMedia.call(navigator, constraints, resolve, reject);
							});
						}
					}
					var constraints = { audio: false, video: { width: ths.data.camera.width, height: ths.data.camera.height, transform: 'scaleX(-1)' } };
					navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
						// 旧的浏览器可能没有srcObject
						if ('srcObject' in window.camera) {
							window.camera.srcObject = stream;
						} else {
							// 避免在新的浏览器中使用它，因为它正在被弃用。
							window.camera.src = window.URL.createObjectURL(stream);
						}
						window.camera.onloadedmetadata = function() {
							window.camera.play();
						}
					}).catch(err => {
						console.log(err);
					});
				}, 50);
			},
			stopCamera() {
				let ths = this;
				if (!ths.$refs['camera'].srcObject) return;
				let stream = ths.$refs['camera'].srcObject;
				let tracks = stream.getTracks();
				tracks.forEach(track => {
					track.stop();
				});
				ths.$refs['camera'].srcObject = null;
				delete window.camera;
				ths.data.camera.doing = false;
			},
			doCamera() {
				let ths = this;
				ths.$refs.cvsCamera.getContext('2d').drawImage(window.camera, 0, 0, ths.data.camera.width, ths.data.camera.height);
				let img = ths.$refs.cvsCamera.toDataURL('image/png');
				ths.data.option.img = img;
				ths.stopCamera();
			},
			reCamera() {
				let ths = this;
				ths.init();
			}
		}
	}
</script>

<style>
	.cropperForm .el-card__header {
		padding: 5px 20px !important;
	}

	.cropperForm .el-card__body {
		padding: 2px !important;
	}
</style>
